import 'core-js/modules/es.string.includes.js';
import { Envs } from '../envs.js';

const isAtSite = () => window.location.origin.includes(getSiteHost());
const getAppHost = () => {
  var _a;
  return (_a = Envs.APP_HOST) !== null && _a !== void 0 ? _a : 'http://localhost:3008';
};
const getSiteHost = () => {
  var _a;
  return (_a = Envs.SITE_HOST) !== null && _a !== void 0 ? _a : 'http://localhost:3000';
};
const getAppUrl = path => {
  return `${getAppHost()}${path}`;
};
const getSiteUrl = path => {
  return `${getSiteHost()}${path}`;
};
const routes = {
  SETTINGS: '/settings',
  PRODUCTS: '/dashboard#products',
  PURCHASES: '/user_groups',
  AFFILIATES: '/affiliate',
  COLLABORATORS: '/collaborators',
  ROLEPLAY: '/roleplay',
  BLOG: 'https://blog.hub.la/',
  SUPPORT: 'https://help.hub.la/hc/pt-br',
  BANK_ACCOUNT: '/account_bank_account',
  VERIFICATION_ACCOUNT: '/account_verification'
};

export { getAppHost, getAppUrl, getSiteHost, getSiteUrl, isAtSite, routes };
